import classNames from 'classnames'
import React from 'react'
import { useBrewDetailStore } from '../../state/useBrewDetailStore'
import Label from '../Label'

const Availability: React.FC = () => {
    const { traits, srm, productData, color } = useBrewDetailStore()
    const availability = traits?.availability
        ? String(traits?.availability).replace(/_/g, ' ')
        : '--'
    const avgSrm = Math.floor((productData?.style?.srmMin + productData?.style?.srmMax) / 2) || null
    const anySrm = srm ? (srm > 40 ? 40 : srm) : avgSrm || color
    const containerClasses = classNames(
        'flex flex-col items-start gap-2',
        anySrm ? 'col-span-1' : 'col-span-2'
    )
    return (
        <div
            className={classNames(
                'flex',
                anySrm || productData?.style?.label ? 'lg:justify-end' : 'justify-start'
            )}
        >
            <div className={containerClasses}>
                <Label labelText='Availability' />
                <span className='text-dark text-lg font-bold'>{availability}</span>
            </div>
        </div>
    )
}

export default Availability
